import {
    cancelAllManagedPendingPromises,
    cancelSpecificTypeOfManagedPromises,
    managePromiseByType,
    PendingPromisesType,
} from "@claroty/utilities/asyncUtils";

class BaseAPI {
    pendingPromises: PendingPromisesType = {}; // Help manage pending promises (and cancel them when needed).
    currentId = { count: 0 };
    managePromiseByType = managePromiseByType.bind(null, this.pendingPromises, this.currentId);
    cancelAllManagedPendingPromises = cancelAllManagedPendingPromises.bind(null, this.pendingPromises);
    cancelSpecificTypeOfManagedPromises = cancelSpecificTypeOfManagedPromises.bind(null, this.pendingPromises);
}

export default BaseAPI;
